<template>
  <div class="f_confirm page_box_bg">
    <!-- //头部 -->
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize sub_icon"></i>
        订单确认
        <div class="rutun" @click="setPage(1)">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div class="refresh_text">刷新</div>
        </div>
      </div>
    </div>
    <!-- //版心部分 -->
    <div v-if="role" class="table_area">
      <!-- //搜索模块 -->
      <div class="search_title">筛选查询</div>
      <div class="clearfix">
        <el-row type="flex" align="middle" class="search_box">
          <el-col :span="2" class="search_label">支付类型:</el-col>
          <el-col :span="5">
            <el-select size="small" clearable v-model="pay_type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-button @click="geting()" size="small">搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <!-- //表格部分 -->
      <div class="content_box">
        <!-- //表格头部 -->
        <div class="table_title">
          <div class="table_title_box">
            <div class="title_icon">
              <i class="fas fa-bars"></i>
            </div>
            <div class="title_text">数据列表</div>
          </div>
        </div>
        <!-- 表格内容 -->
        <div class="table">
          <el-table
            :data="tableData"
            border
            class="table_w"
            ref="multipleTable"
            @selection-change="Select"
          >
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column prop="orderCode" width="200" label="订单编号" align="center"></el-table-column>
            <el-table-column prop="address" label="订货人" align="center"></el-table-column>
            <el-table-column prop="pay_type" label="支付类型" align="center"></el-table-column>
            <el-table-column prop="payway" label="支付方式" align="center"></el-table-column>
            <el-table-column prop="pay_money" label="金额" align="center"></el-table-column>
            <el-table-column prop="create_time" width="200" label="下单时间" align="center"></el-table-column>
            <el-table-column label="操作" width="200" align="center" name="bianji">
              <template slot-scope="scope">
                <el-button size="small" @click="audit(scope.row.orderCode)">审核通过</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页部分 -->
        <div class="page_box clearfix">
          <div class="batach_check">
            <el-button size="small" @click="audit_more()">批量审核</el-button>
          </div>
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              :current-page.sync="page"
              @current-change="setPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
import "./../../assets/all.css";
export default {
  name: "f_confirm",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      options: [
        {
          label: "账期支付",
          value: "1"
        },
        {
          label: "支付宝支付",
          value: "2"
        },
        {
          label: "微信支付",
          value: "3"
        },
        {
          label: "余额支付",
          value: "4"
        },
        {
          label: "转账支付",
          value: "5"
        }
      ],
      pay_type: "",
      tableData: [],
      page: 0,
      total: 0
    };
  },
  created() {
    this.$store.state.topActiveId = 11;
    this.$store.state.leftTitle = "订单确认";
    this.geting(1);
  },
  mounted() {},
  methods: {
    Select(val) {
      var orderList = [];
      for (var i in val) {
        orderList.push(val[i].orderCode);
      }
      this.order_list = JSON.stringify(orderList);
    },
    audit_more() {
      this.axios
        .get(this.serve + "/admin/finance_check_agree", {
          params: {
            username: this.username,
            token: this.token,
            orderCodeList: this.order_list
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.setPage(this.page - 1);
            this.$message({
              type: "success",
              message: "操作成功"
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    audit(orderCode) {
      this.$confirm("此操作审核订单, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/finance_check_agree", {
              params: {
                username: this.username,
                token: this.token,
                orderCode: orderCode
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.geting();
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
              } else if (res.data.status == "error") {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    setPage(v) {
      //分页
      this.page = Number(v);
      this.geting(v);
    },

    geting(page) {
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/finance_check_list", {
          params: {
            page: page,
            token: this.token,
            username: this.username,
            pay_type: this.pay_type
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            that.tableData = [];
            var json = res.data.data;
            if (res.data.status == "success") {
              for (var key in json.results) {
                this.tableData.push(json.results[key]);
                if (json.results[key].pay_type == 1) {
                  json.results[key].pay_type = "在线支付";
                } else if (json.results[key].pay_type == 2) {
                  json.results[key].pay_type = "账期支付";
                }
                if (json.results[key].payway == 3) {
                  json.results[key].payway = "微信支付";
                } else if (json.results[key].payway == 2) {
                  json.results[key].payway = "支付宝支付";
                } else if (json.results[key].payway == 4) {
                  json.results[key].payway = "余额支付";
                } else if (json.results[key].payway == 5) {
                  json.results[key].payway = "后台支付";
                } else if (json.results[key].payway == 0) {
                  json.results[key].payway = "未支付";
                }
                var address = json.results[key].address;
                json.results[key].address = address.split(";")[1];
                var timeNew = new Date(
                  parseInt(json.results[key].create_time) * 1000
                )
                  .toLocaleString()
                  .replace(/:\d{1,2}$/, " ");
                json.results[key].create_time = timeNew;
              }
              that.total = json.total;
              that.page = Number(json.page);
            }
          } else {
           
            that.total = 0;
            that.page = 1;
            that.tableData = [];
            if (res.data.msg == "无权访问") {
              that.role = false;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.f_confirm {
  padding-bottom: 30px;
  .batach_check {
    float: left;
  }
}
</style>